'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _strategies = require('./strategies');

var _strategies2 = _interopRequireDefault(_strategies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _columnMatches = function _columnMatches(_ref) {
  var query = _ref.query;
  var _ref$column = _ref.column;
  var column = _ref$column === undefined ? {} : _ref$column;
  var row = _ref.row;
  var _ref$strategy = _ref.strategy;
  var strategy = _ref$strategy === undefined ? _strategies2.default.infix : _ref$strategy;
  var _ref$transform = _ref.transform;
  var transform = _ref$transform === undefined ? function () {
    var v = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
    return v && v.toLowerCase && v.toLowerCase();
  } : _ref$transform;

  var property = column.property;
  // Pick resolved value by convention
  var resolvedValue = String(row['_' + property] || row[property]);

  return strategy(transform(query)).evaluate(transform(resolvedValue));
};

exports.default = _columnMatches;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-search/dist/_column_matches.js
// module id = 364
// module chunks = 0